import { Form, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';

const PropertiesDropDown = props => {
  return (
    <Form.Field error={Boolean(props.error)}>
      <label htmlFor={props.name}>{props.label}</label>
      <Dropdown
        fluid
        search
        selection
        clearable
        key={props.id ? props.id + '-' + props.name : props.name}
        options={props.options}
        id={props.name}
        data-testid={props.name}
        name={props.name}
        value={props.value ? props.value : props.options[1].value}
        onChange={(e, d) => props.formik.setFieldValue(d.name, d.value)}
      />
    </Form.Field>
  );
};

const mapStateToProps = state => ({
  options: state.admin.propertiesOptions,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesDropDown);
